import React, { useState } from 'react'
import { Card, Flex, Collapse, Typography, Space, theme, Select, Radio, Tag, Checkbox } from 'antd'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

const { Title } = Typography;

const LeftFilterFindJob = () => {

    const { token } = theme.useToken();
    const [value, setValue] = useState(null);
    const onChange = (e) => {
        setValue(e.target.value);
    };

    const onChangecheck = (checkedValues) => {
        console.log('checked = ', checkedValues);
      };
    
    const getItems = (panelStyle) => [
        {
            key: '1',
            label: 'Distance',
            children: 
            <Select
                defaultValue={'10 miles'}
                className='field-select w-100 mt-2'
                options={[
                {
                    value: '1',
                    label: '10 miles',
                },
                {
                    value: '2',
                    label: '20 miles',
                },
                {
                    value: '1',
                    label: '30 miles',
                },
            ]}
            />,
            style: panelStyle,
        },

        {
            key: '2',
            label: 'Date Posted',
            children: 
            <Radio.Group onChange={onChange} value={value} className='mt-2 w-100'>
                <Space direction="vertical" className='w-100'>
                    <Flex justify='space-between' className='w-100'>
                        <Radio value={1}>Last 48 hours</Radio>
                        <Tag className='text-brown'>789</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Radio value={2}>Last 30 days</Radio>
                        <Tag className='text-brown'>1000</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Radio value={3}>more than 30 days</Radio>
                        <Tag className='text-brown'>1100</Tag>
                    </Flex>
                </Space>
            </Radio.Group>,
            style: panelStyle,
        },

        {
            key: '3',
            label: 'Salary Range',
            children: 
            <Space direction='vertical' className='mt-2 w-100'>
                <Select
                    placeholder='From'
                    className='field-select w-100 '
                    options={[
                    {
                        value: '1',
                        label: '$1000',
                    },
                    {
                        value: '2',
                        label: '$2000',
                    },
                    {
                        value: '1',
                        label: '$3000',
                    },
                ]}
                />
                <Select
                    placeholder='To'
                    className='field-select w-100 '
                    options={[
                    {
                        value: '1',
                        label: '$5000',
                    },
                    {
                        value: '2',
                        label: '$10000',
                    },
                    {
                        value: '1',
                        label: '$2000',
                    },
                ]}
                />
            </Space>,
            style: panelStyle,
        },

        {
            key: '4',
            label: 'Type of job',
            children: 
            <Checkbox.Group onChange={onChangecheck} className='mt-2 w-100'>
                <Space direction="vertical" className='w-100'>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'1'}>Exclude student jobs</Checkbox>
                        <Tag className='text-brown'>789</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'2'}>Student jobs</Checkbox>
                        <Tag className='text-brown'>1000</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'3'}>Internship</Checkbox>
                        <Tag className='text-brown'>1100</Tag>
                    </Flex>
                </Space>
            </Checkbox.Group>,
            style: panelStyle,
        },

        {
            key: '5',
            label: 'Hours of work',
            children: 
            <Checkbox.Group onChange={onChangecheck} className='mt-2 w-100'>
                <Space direction="vertical" className='w-100'>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'a'}>Full time</Checkbox>
                        <Tag className='text-brown'>1789</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'b'}>Part time</Checkbox>
                        <Tag className='text-brown'>1000</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'c'}>Remote work</Checkbox>
                        <Tag className='text-brown'>1100</Tag>
                    </Flex>
                </Space>
            </Checkbox.Group>,
            style: panelStyle,
        },

        {
            key: '6',
            label: 'Period of employement',
            children: 
            <Checkbox.Group onChange={onChangecheck} className='mt-2 w-100'>
                <Space direction="vertical" className='w-100'>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'4'}>Permanent</Checkbox>
                        <Tag className='text-brown'>1789</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'5'}>Terms or Contract</Checkbox>
                        <Tag className='text-brown'>900</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'6'}>Seasonal</Checkbox>
                        <Tag className='text-brown'>800</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'7'}>Casual/</Checkbox>
                        <Tag className='text-brown'>999</Tag>
                    </Flex>
                </Space>
            </Checkbox.Group>,
            style: panelStyle,
        },

        {
            key: '7',
            label: 'Specialisms',
            children: 
            <Checkbox.Group onChange={onChangecheck} className='mt-2 w-100'>
                <Space direction="vertical" className='w-100'>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'8'}>Education</Checkbox>
                        <Tag className='text-brown'>1789</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'9'}>Accountancy</Checkbox>
                        <Tag className='text-brown'>900</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'10'}>Sales</Checkbox>
                        <Tag className='text-brown'>800</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'11'}>Customer services</Checkbox>
                        <Tag className='text-brown'>999</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'12'}>Estate agency</Checkbox>
                        <Tag className='text-brown'>1299</Tag>
                    </Flex>
                </Space>
            </Checkbox.Group>,
            style: panelStyle,
        },
        {
            key: '7',
            label: 'Location',
            children: 
            <Checkbox.Group onChange={onChangecheck} className='mt-2 w-100'>
                <Space direction="vertical" className='w-100'>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'13'}>ABC</Checkbox>
                        <Tag className='text-brown'>1789</Tag>
                    </Flex>
                    <Flex justify='space-between' className='w-100'>
                        <Checkbox value={'14'}>XYZ</Checkbox>
                        <Tag className='text-brown'>900</Tag>
                    </Flex>
                </Space>
            </Checkbox.Group>,
            style: panelStyle,
        },

    ];
    
        const panelStyle = {
            marginBottom: 10,
            padding: 0,
            background: token.colorFillAlter,
            borderRadius: token.borderRadiusLG,
            border: 'none',
        };

    return (
        <div>
            <Flex vertical gap={10} className='mb-2'>
                <Title level={5} className=''>
                    Applied filters
                </Title>
                <Flex wrap gap={5}>
                    <Tag closeIcon closable>
                        data entry
                    </Tag>
                    <Tag closeIcon closable>
                        part time
                    </Tag>
                    <Tag closeIcon closable>
                        london
                    </Tag>
                    <Tag closeIcon closable>
                        full time
                    </Tag>
                    
                </Flex>
            </Flex>    
            <Card className='shadow-c rounded0 mb-3'>
                <Flex vertical className='w-100'>
                    <Title level={5} className=''>
                        Filter your search
                    </Title>
                    <Collapse
                        bordered={false}
                        defaultActiveKey={getItems(panelStyle)?.map(item => item.key)}
                        className="collapse-cs"
                        expandIconPosition="end"
                        expandIcon={({ isActive }) => (
                            <Space>
                                <span>
                                    {getItems?.label}
                                </span>
                                {isActive ? <MinusOutlined /> : <PlusOutlined />}
                            </Space>
                        )}
                        items={getItems(panelStyle)}
                    />
                </Flex>
            </Card>
        </div>
    )
}

export { LeftFilterFindJob }